// @flow

// Components
import AddIcon from 'fc-icons/src/Add'
import Button from '@react-mdc/button'
// Libs
import React, { Component } from 'react'

type Props = {
  title: string,
  onClick: Function,
  disabled: ?boolean,
}

// TODO: Fix styling on this
const styles = {
  button: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonDisabled: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'grey',
  },
}
export default class AddJobButton extends Component {
  props: Props

  render(): ?React.Element<any> {
    const title = this.props.title ? this.props.title : ''
    const disabled = this.props.disabled ? this.props.disabled : false
    const style = disabled ? styles.buttonDisabled : styles.button
    return (
      <Button raised primary disabled={disabled} onClick={this.props.onClick} style={style} title={title}>
        <AddIcon color={'white'} /> Add a Job
      </Button>
    )
  }
}
